import React from 'react';
import { PS } from '../theme';
import { Chip } from '../lib/ui';
import { Icon } from '../lib/icons';
import { thb } from '../lib/format';

export default function CircleSchedule({ rounds }) {
  return (
    <>
      <div style={{ padding: '0 20px 10px', fontSize: 15, fontWeight: 600 }}>กำหนดการ</div>
      <div style={{ margin: '0 16px 16px', background: PS.surface, border: `1px solid ${PS.line}`, borderRadius: 18, overflow: 'hidden' }}>
        {(rounds || []).map((r, i, arr) => {
          const isLive = r.status === 'live';
          return (
            <div key={r.round_id} style={{ padding: '12px 16px', borderBottom: i < arr.length - 1 ? `1px solid ${PS.lineSoft}` : 'none', background: isLive ? 'oklch(0.62 0.12 38 / 0.06)' : 'transparent', display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ width: 32, textAlign: 'center' }}>
                <div className="num" style={{ fontSize: 18, color: isLive ? 'oklch(0.42 0.12 38)' : PS.text }}>{r.round_number}</div>
                <div style={{ fontSize: 9, color: PS.textMuted, letterSpacing: 0.5 }}>{(r.scheduled_date || '').split(' ')[1]}</div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 12.5, fontWeight: 500 }}>{isLive ? 'นัดประมูลครั้งถัดไป' : r.status === 'future' ? 'รอบถัดไป' : `${r.winner_name} ได้เปีย`}</div>
                <div style={{ fontSize: 11, color: PS.textMuted, marginTop: 1 }}>{r.status === 'done' ? `ดอกเปีย ${thb(r.winning_bid)} · ยอดรับ ${thb(r.pot_amount)}` : `${r.venue || ''} · ${r.scheduled_date}`}</div>
              </div>
              {isLive ? <Chip tone="terra">กำลังมา</Chip> : r.status === 'future' ? <Chip tone="outline">รอ</Chip> : <Chip tone="green"><Icon.check size={10} stroke="currentColor" />เสร็จ</Chip>}
            </div>
          );
        })}
      </div>
    </>
  );
}
